/* eslint-disable max-len */
define({
    ok: 'OK',
    cancel: 'キャンセル',
    standardColors: '標準の色',
    customColors: 'カスタム色',
    recentColors: '最近使用した色',
    preview: 'プレビュー',
    redTitle: 'R', // Used for label for three edit fields to enter [R, G, B] color
    greenTitle: 'G', // Used for label for three edit fields to enter [R, G, B] color
    blueTitle: 'B', // Used for label for three edit fields to enter [R, G, B] color
    hexTitle: '16 進数', // Used for label for to enter hex color
    hueTitle: 'H', // Used for label for three edit fields to enter [H, S, V] color
    saturationTitle: 'S', // Used for label for three edit fields to enter [H, S, V] color
    valueTitle: 'V', // Used for label for three edit fields to enter [H, S, V] color
    doubleLabel: 'RGB [0-1]',
    intLabel: 'RGB [0-255]',
    hexLabel: '16 進数',
    hsvLabel: 'HSV',
    auto: '自動',
    none: 'なし',
    flat: 'フラット',
    interp: '内挿',
    texturemap: 'テクスチャマップ',
    invalidHexErrorMessage: '値は有効な 16 進数形式でなければなりません。'
});
